export default __webpack_public_path__ + "fonts/Roboto-400-vietnamese12.woff2";